import styled from 'styled-components'

export const Avatar = styled.img`
  width: 8rem;
  height: auto;
  margin: -1rem auto 1rem auto;
`
export const Details = styled.p`
  color: ${({ theme }) => theme.colors.textColor};
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
`
